export const AUTRES_SKILLS = [
  { nom: "Git",            image: "/assets/img/icon/stack/git.webp" },
  { nom: "GitHub Actions", image: "/assets/img/icon/stack/githubactions.webp" },
  { nom: "pytest",         image: "/assets/img/icon/stack/pytest.webp" },
  { nom: "jQuery",         image: "/assets/img/icon/stack/jquery.webp" },
];
